import PreventionPlans from './Constructor'

export default PreventionPlans
export { PreventionPlans }
